export default __webpack_public_path__ + "static/media/093-move.f4eacf43.png";